import { render, staticRenderFns } from "./component.main-plan-block-v2.vue?vue&type=template&id=7a67a4e6"
import script from "./component.main-plan-block-v2.vue?vue&type=script&lang=js"
export * from "./component.main-plan-block-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports